// src/themes/arctic-breeze.ts
import { Theme } from "./types";

export const arcticBreezeTheme: Theme = {
  "background-light": "240 248 255", // #F0F8FF - Alice Blue
  "background-dark": "230 240 250", // #E6F0FA - Soft ice blue
  "card-light": "255 255 255", // #FFFFFF - Pure white
  "card-dark": "248 250 252", // #F8FAFC - Snow white
  "input-light": "245 249 255", // #F5F9FF - Frosted glass
  "input-dark": "240 245 252", // #F0F5FC - Soft frost
  "border-light": "200 225 255", // #C8E1FF - Ice border
  "border-dark": "180 215 250", // #B4D7FA - Cool border
  primary: "0 150 255", // #0096FF - Bright azure
  "primary-hover": "0 130 230", // #0082E6 - Deep azure
  text: "30 40 70", // #1E2846 - Deep navy
  "text-dark": "40 50 80", // #283250 - Rich navy
  "text-secondary": "100 120 160", // #6478A0 - Cool gray-blue
  "text-secondary-dark": "80 100 140", // #50648C - Muted blue-gray
};
